import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryActionLabel?: string;
  onSecondaryAction?: () => void;
}

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
  min-height: 400px;
`;

const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.2);

  svg {
    color: white;
  }
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
  font-family: 'Gilroy', -apple-system, BlinkMacSystemFont, sans-serif;
`;

const Description = styled.p`
  font-size: 14px;
  color: #64748b;
  margin-bottom: 32px;
  max-width: 400px;
  line-height: 1.6;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction
}) => {
  return (
    <EmptyStateContainer>
      <IconWrapper>
        <Icon size={40} />
      </IconWrapper>

      <Title>{title}</Title>
      <Description>{description}</Description>

      {(actionLabel || secondaryActionLabel) && (
        <ActionButtons>
          {actionLabel && onAction && (
            <Button
              type="primary"
              size="large"
              onClick={onAction}
              style={{
                height: '44px',
                padding: '0 28px',
                fontSize: '15px',
                fontWeight: 500,
                borderRadius: '8px'
              }}
            >
              {actionLabel}
            </Button>
          )}

          {secondaryActionLabel && onSecondaryAction && (
            <Button
              size="large"
              onClick={onSecondaryAction}
              style={{
                height: '44px',
                padding: '0 28px',
                fontSize: '15px',
                fontWeight: 500,
                borderRadius: '8px'
              }}
            >
              {secondaryActionLabel}
            </Button>
          )}
        </ActionButtons>
      )}
    </EmptyStateContainer>
  );
};

export default EmptyState;
